module.exports = __webpack_public_path__ + "media/screencapture.3f16a1ac.mp4";